import Head from "next/head"
import { DefaultLayout } from "src/components/Layout"
import { Auth } from "src/features/auth"
import { PdfContainer } from "src/features/pdf/components/PdfContainer/PdfContainer"
import { NextPage } from "next"

const PdfPage: NextPage = () => {
  return (
    <DefaultLayout>
      <Head>
        <title>POP/ポスター作成 | for CS</title>
      </Head>
      <Auth>
        <PdfContainer />
      </Auth>
    </DefaultLayout>
  )
}

export default PdfPage
